// ** React Imports
import { lazy } from 'react';

const List = lazy(() => import('../../views/audioHistory'));

const AudioHistoryRoutes = [
  {
    element: <List />,
    path: '/audioHistory',
    meta: {
      permission: 'AUDIOHISTORY'
    }
  }
];

export default AudioHistoryRoutes;
